var _defs, _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _text9, _text10, _text11, _text12, _text13, _text14, _text15, _text16, _text17, _text18, _text19, _text20, _text21, _text22, _text23, _text24, _text25, _text26, _text27, _text28, _text29, _text30, _text31, _text32, _text33, _text34, _text35, _text36, _text37;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImage3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    contentScriptType: "application/ecmascript",
    contentStyleType: "text/css",
    height: "524px",
    preserveAspectRatio: "none",
    style: {
      width: 1037,
      height: 524
    },
    viewBox: "0 0 1037 524",
    width: "1037px",
    zoomAndPan: "magnify",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    height: "300%",
    id: "f5hxzkyptxe8x",
    width: "300%",
    x: -1,
    y: -1
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blurOut",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blurOut",
    result: "blurOut2",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 .4 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4,
    in: "blurOut2",
    result: "blurOut3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "blurOut3",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "#F9F9F9",
    height: 509.0469,
    style: {
      stroke: "#DDDDDD",
      strokeWidth: 1
    },
    width: 163,
    x: 273.5,
    y: 4
  }), _text || (_text = /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "sans-serif",
    fontSize: 14,
    fontWeight: "bold",
    lengthAdjust: "spacingAndGlyphs",
    textLength: 157,
    x: 276.5,
    y: 16.9951
  }, "Client can be Issuer")), /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "#777777",
      strokeWidth: 1,
      strokeDasharray: "5.0,5.0"
    },
    x1: 75,
    x2: 75,
    y1: 59.5938,
    y2: 458.4531
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "#777777",
      strokeWidth: 1,
      strokeDasharray: "5.0,5.0"
    },
    x1: 319.5,
    x2: 319.5,
    y1: 59.5938,
    y2: 458.4531
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "#777777",
      strokeWidth: 1,
      strokeDasharray: "5.0,5.0"
    },
    x1: 388.5,
    x2: 388.5,
    y1: 59.5938,
    y2: 458.4531
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "#777777",
      strokeWidth: 1,
      strokeDasharray: "5.0,5.0"
    },
    x1: 577.5,
    x2: 577.5,
    y1: 59.5938,
    y2: 458.4531
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "#777777",
      strokeWidth: 1,
      strokeDasharray: "5.0,5.0"
    },
    x1: 963.5,
    x2: 963.5,
    y1: 59.5938,
    y2: 458.4531
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FEFECE",
    filter: "url(#f5hxzkyptxe8x)",
    height: 46.5938,
    style: {
      stroke: "#A80036",
      strokeWidth: 1.5
    },
    width: 130,
    x: 8,
    y: 8
  }), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "sans-serif",
    fontSize: 14,
    lengthAdjust: "spacingAndGlyphs",
    textLength: 116,
    x: 15,
    y: 27.9951
  }, "Resource Owner")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "sans-serif",
    fontSize: 14,
    lengthAdjust: "spacingAndGlyphs",
    textLength: 78,
    x: 36,
    y: 44.292
  }, "User-Agent")), /*#__PURE__*/React.createElement("rect", {
    fill: "#FEFECE",
    filter: "url(#f5hxzkyptxe8x)",
    height: 46.5938,
    style: {
      stroke: "#A80036",
      strokeWidth: 1.5
    },
    width: 130,
    x: 8,
    y: 457.4531
  }), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "sans-serif",
    fontSize: 14,
    lengthAdjust: "spacingAndGlyphs",
    textLength: 116,
    x: 15,
    y: 477.4482
  }, "Resource Owner")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "sans-serif",
    fontSize: 14,
    lengthAdjust: "spacingAndGlyphs",
    textLength: 78,
    x: 36,
    y: 493.7451
  }, "User-Agent")), /*#__PURE__*/React.createElement("rect", {
    fill: "#FEFECE",
    filter: "url(#f5hxzkyptxe8x)",
    height: 30.2969,
    style: {
      stroke: "#A80036",
      strokeWidth: 1.5
    },
    width: 53,
    x: 291.5,
    y: 24.2969
  }), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "sans-serif",
    fontSize: 14,
    lengthAdjust: "spacingAndGlyphs",
    textLength: 39,
    x: 298.5,
    y: 44.292
  }, "Client")), /*#__PURE__*/React.createElement("rect", {
    fill: "#FEFECE",
    filter: "url(#f5hxzkyptxe8x)",
    height: 30.2969,
    style: {
      stroke: "#A80036",
      strokeWidth: 1.5
    },
    width: 53,
    x: 291.5,
    y: 457.4531
  }), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "sans-serif",
    fontSize: 14,
    lengthAdjust: "spacingAndGlyphs",
    textLength: 39,
    x: 298.5,
    y: 477.4482
  }, "Client")), /*#__PURE__*/React.createElement("rect", {
    fill: "#FEFECE",
    filter: "url(#f5hxzkyptxe8x)",
    height: 30.2969,
    style: {
      stroke: "#A80036",
      strokeWidth: 1.5
    },
    width: 56,
    x: 358.5,
    y: 24.2969
  }), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "sans-serif",
    fontSize: 14,
    lengthAdjust: "spacingAndGlyphs",
    textLength: 42,
    x: 365.5,
    y: 44.292
  }, "Issuer")), /*#__PURE__*/React.createElement("rect", {
    fill: "#FEFECE",
    filter: "url(#f5hxzkyptxe8x)",
    height: 30.2969,
    style: {
      stroke: "#A80036",
      strokeWidth: 1.5
    },
    width: 56,
    x: 358.5,
    y: 457.4531
  }), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "sans-serif",
    fontSize: 14,
    lengthAdjust: "spacingAndGlyphs",
    textLength: 42,
    x: 365.5,
    y: 477.4482
  }, "Issuer")), /*#__PURE__*/React.createElement("rect", {
    fill: "#FEFECE",
    filter: "url(#f5hxzkyptxe8x)",
    height: 30.2969,
    style: {
      stroke: "#A80036",
      strokeWidth: 1.5
    },
    width: 153,
    x: 499.5,
    y: 24.2969
  }), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "sans-serif",
    fontSize: 14,
    lengthAdjust: "spacingAndGlyphs",
    textLength: 139,
    x: 506.5,
    y: 44.292
  }, "Authorization Server")), /*#__PURE__*/React.createElement("rect", {
    fill: "#FEFECE",
    filter: "url(#f5hxzkyptxe8x)",
    height: 30.2969,
    style: {
      stroke: "#A80036",
      strokeWidth: 1.5
    },
    width: 153,
    x: 499.5,
    y: 457.4531
  }), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "sans-serif",
    fontSize: 14,
    lengthAdjust: "spacingAndGlyphs",
    textLength: 139,
    x: 506.5,
    y: 477.4482
  }, "Authorization Server")), /*#__PURE__*/React.createElement("rect", {
    fill: "#FEFECE",
    filter: "url(#f5hxzkyptxe8x)",
    height: 30.2969,
    style: {
      stroke: "#A80036",
      strokeWidth: 1.5
    },
    width: 129,
    x: 897.5,
    y: 24.2969
  }), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "sans-serif",
    fontSize: 14,
    lengthAdjust: "spacingAndGlyphs",
    textLength: 115,
    x: 904.5,
    y: 44.292
  }, "Resource Server")), /*#__PURE__*/React.createElement("rect", {
    fill: "#FEFECE",
    filter: "url(#f5hxzkyptxe8x)",
    height: 30.2969,
    style: {
      stroke: "#A80036",
      strokeWidth: 1.5
    },
    width: 129,
    x: 897.5,
    y: 457.4531
  }), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "sans-serif",
    fontSize: 14,
    lengthAdjust: "spacingAndGlyphs",
    textLength: 115,
    x: 904.5,
    y: 477.4482
  }, "Resource Server")), /*#__PURE__*/React.createElement("polygon", {
    fill: "#A80036",
    points: "86,87.8906,76,91.8906,86,95.8906,82,91.8906",
    style: {
      stroke: "#A80036",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "#A80036",
      strokeWidth: 2
    },
    x1: 80,
    x2: 319,
    y1: 91.8906,
    y2: 91.8906
  }), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "sans-serif",
    fontSize: 14,
    fontWeight: "bold",
    lengthAdjust: "spacingAndGlyphs",
    textLength: 16,
    x: 92,
    y: 86.5889
  }, "1)")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "sans-serif",
    fontSize: 14,
    lengthAdjust: "spacingAndGlyphs",
    textLength: 74,
    x: 112,
    y: 86.5889
  }, "Redirect....")), /*#__PURE__*/React.createElement("polygon", {
    fill: "#A80036",
    points: "376.5,118.1875,386.5,122.1875,376.5,126.1875,380.5,122.1875",
    style: {
      stroke: "#A80036",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "#A80036",
      strokeWidth: 2
    },
    x1: 75,
    x2: 382.5,
    y1: 122.1875,
    y2: 122.1875
  }), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "sans-serif",
    fontSize: 14,
    fontWeight: "bold",
    lengthAdjust: "spacingAndGlyphs",
    textLength: 16,
    x: 82,
    y: 116.8857
  }, "2)")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "sans-serif",
    fontSize: 14,
    lengthAdjust: "spacingAndGlyphs",
    textLength: 137,
    x: 102,
    y: 116.8857
  }, "...for authentication.")), /*#__PURE__*/React.createElement("polygon", {
    fill: "#A80036",
    points: "86,148.4844,76,152.4844,86,156.4844,82,152.4844",
    style: {
      stroke: "#A80036",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "#A80036",
      strokeWidth: 2
    },
    x1: 80,
    x2: 387.5,
    y1: 152.4844,
    y2: 152.4844
  }), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "sans-serif",
    fontSize: 14,
    fontWeight: "bold",
    lengthAdjust: "spacingAndGlyphs",
    textLength: 16,
    x: 92,
    y: 147.1826
  }, "3)")), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "sans-serif",
    fontSize: 14,
    lengthAdjust: "spacingAndGlyphs",
    textLength: 220,
    x: 112,
    y: 147.1826
  }, "If credentials are valid, redirect...")), /*#__PURE__*/React.createElement("polygon", {
    fill: "#A80036",
    points: "308,195.0781,318,199.0781,308,203.0781,312,199.0781",
    style: {
      stroke: "#A80036",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "#A80036",
      strokeWidth: 2
    },
    x1: 75,
    x2: 314,
    y1: 199.0781,
    y2: 199.0781
  }), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "sans-serif",
    fontSize: 14,
    fontWeight: "bold",
    lengthAdjust: "spacingAndGlyphs",
    textLength: 16,
    x: 82,
    y: 185.6279
  }, "4)")), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "sans-serif",
    fontSize: 14,
    lengthAdjust: "spacingAndGlyphs",
    textLength: 187,
    x: 102,
    y: 177.4795
  }, "...with signed bearer JWT to")), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "sans-serif",
    fontSize: 14,
    lengthAdjust: "spacingAndGlyphs",
    textLength: 39,
    x: 102,
    y: 193.7764
  }, "Client")), /*#__PURE__*/React.createElement("polygon", {
    fill: "#A80036",
    points: "566,241.6719,576,245.6719,566,249.6719,570,245.6719",
    style: {
      stroke: "#A80036",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "#A80036",
      strokeWidth: 2
    },
    x1: 320,
    x2: 572,
    y1: 245.6719,
    y2: 245.6719
  }), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "sans-serif",
    fontSize: 14,
    fontWeight: "bold",
    lengthAdjust: "spacingAndGlyphs",
    textLength: 16,
    x: 327,
    y: 232.2217
  }, "5)")), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "sans-serif",
    fontSize: 14,
    lengthAdjust: "spacingAndGlyphs",
    textLength: 156,
    x: 347,
    y: 224.0732
  }, "Request access token")), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "sans-serif",
    fontSize: 14,
    lengthAdjust: "spacingAndGlyphs",
    textLength: 57,
    x: 347,
    y: 240.3701
  }, "with JWT")), /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "#A80036",
      strokeWidth: 2
    },
    x1: 578,
    x2: 620,
    y1: 275.9688,
    y2: 275.9688
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "#A80036",
      strokeWidth: 2
    },
    x1: 620,
    x2: 620,
    y1: 275.9688,
    y2: 288.9688
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "#A80036",
      strokeWidth: 2
    },
    x1: 579,
    x2: 620,
    y1: 288.9688,
    y2: 288.9688
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#A80036",
    points: "589,284.9688,579,288.9688,589,292.9688,585,288.9688",
    style: {
      stroke: "#A80036",
      strokeWidth: 1
    }
  }), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "sans-serif",
    fontSize: 14,
    fontWeight: "bold",
    lengthAdjust: "spacingAndGlyphs",
    textLength: 16,
    x: 585,
    y: 270.667
  }, "6)")), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "sans-serif",
    fontSize: 14,
    lengthAdjust: "spacingAndGlyphs",
    textLength: 83,
    x: 605,
    y: 270.667
  }, "Validate JWT")), /*#__PURE__*/React.createElement("polygon", {
    fill: "#A80036",
    points: "331,315.2656,321,319.2656,331,323.2656,327,319.2656",
    style: {
      stroke: "#A80036",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "#A80036",
      strokeWidth: 2
    },
    x1: 325,
    x2: 577,
    y1: 319.2656,
    y2: 319.2656
  }), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "sans-serif",
    fontSize: 14,
    fontWeight: "bold",
    lengthAdjust: "spacingAndGlyphs",
    textLength: 16,
    x: 337,
    y: 313.9639
  }, "7)")), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "sans-serif",
    fontSize: 14,
    lengthAdjust: "spacingAndGlyphs",
    textLength: 200,
    x: 357,
    y: 313.9639
  }, "Response with access token")), /*#__PURE__*/React.createElement("polygon", {
    fill: "#A80036",
    points: "952,345.5625,962,349.5625,952,353.5625,956,349.5625",
    style: {
      stroke: "#A80036",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "#A80036",
      strokeWidth: 2
    },
    x1: 320,
    x2: 958,
    y1: 349.5625,
    y2: 349.5625
  }), _text30 || (_text30 = /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "sans-serif",
    fontSize: 14,
    fontWeight: "bold",
    lengthAdjust: "spacingAndGlyphs",
    textLength: 16,
    x: 327,
    y: 344.2607
  }, "8)")), _text31 || (_text31 = /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "sans-serif",
    fontSize: 14,
    lengthAdjust: "spacingAndGlyphs",
    textLength: 254,
    x: 347,
    y: 344.2607
  }, "Request resource with access token")), /*#__PURE__*/React.createElement("polygon", {
    fill: "#A80036",
    points: "589,375.8594,579,379.8594,589,383.8594,585,379.8594",
    style: {
      stroke: "#A80036",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "#A80036",
      strokeWidth: 2
    },
    x1: 583,
    x2: 963,
    y1: 379.8594,
    y2: 379.8594
  }), _text32 || (_text32 = /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "sans-serif",
    fontSize: 14,
    fontWeight: "bold",
    lengthAdjust: "spacingAndGlyphs",
    textLength: 16,
    x: 595,
    y: 374.5576
  }, "9)")), _text33 || (_text33 = /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "sans-serif",
    fontSize: 14,
    lengthAdjust: "spacingAndGlyphs",
    textLength: 282,
    x: 615,
    y: 374.5576
  }, "Request token validation and information")), /*#__PURE__*/React.createElement("polygon", {
    fill: "#A80036",
    points: "952,406.1563,962,410.1563,952,414.1563,956,410.1563",
    style: {
      stroke: "#A80036",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "#A80036",
      strokeWidth: 2
    },
    x1: 578,
    x2: 958,
    y1: 410.1563,
    y2: 410.1563
  }), _text34 || (_text34 = /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "sans-serif",
    fontSize: 14,
    fontWeight: "bold",
    lengthAdjust: "spacingAndGlyphs",
    textLength: 26,
    x: 585,
    y: 404.8545
  }, "10)")), _text35 || (_text35 = /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "sans-serif",
    fontSize: 14,
    lengthAdjust: "spacingAndGlyphs",
    textLength: 332,
    x: 615,
    y: 404.8545
  }, "If access token is valid, respond with information")), /*#__PURE__*/React.createElement("polygon", {
    fill: "#A80036",
    points: "331,436.4531,321,440.4531,331,444.4531,327,440.4531",
    style: {
      stroke: "#A80036",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "#A80036",
      strokeWidth: 2
    },
    x1: 325,
    x2: 963,
    y1: 440.4531,
    y2: 440.4531
  }), _text36 || (_text36 = /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "sans-serif",
    fontSize: 14,
    fontWeight: "bold",
    lengthAdjust: "spacingAndGlyphs",
    textLength: 26,
    x: 337,
    y: 435.1514
  }, "11)")), _text37 || (_text37 = /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "sans-serif",
    fontSize: 14,
    lengthAdjust: "spacingAndGlyphs",
    textLength: 341,
    x: 367,
    y: 435.1514
  }, "If access token is valid, return protected resource"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage3);
export default __webpack_public_path__ + "static/media/image_3.4bc75e48e527e3a94b6c73cf4ecf9daf.svg";
export { ForwardRef as ReactComponent };